import { FileText, MessageSquare } from "lucide-react";

interface HeroProps {
  onOpenModal: (type: "surat" | "aspirasi" | "login" | "umkm") => void;
}

export default function Hero({ onOpenModal }: HeroProps) {
  return (
    <section id="beranda" className="bg-[#005c32] pt-[72px] sm:pt-[76px]">
      {/* 1. Header Banner Image - Fully visible, unobscured, flush with header */}
      <div className="w-full relative bg-[#005c32] overflow-hidden">
        <img 
          src="/images/background_header_17-08-2026_01.png" 
          alt="Banner Header 17 Agustus Cibubur Villa 2" 
          className="w-full h-auto block object-top"
          referrerPolicy="no-referrer"
          fetchPriority="high"
          loading="eager"
        />
      </div>

      {/* 2. Portal Card - Positioned directly above the 4 Stats cards */}
      <div className="bg-slate-50 pt-6 sm:pt-8 pb-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-r from-[#004d2a] via-[#004022] to-[#00331b] text-white rounded-3xl p-6 sm:p-8 shadow-xl border border-emerald-800/40 relative overflow-hidden">
          {/* Subtle background glow */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#ffd22e]/10 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#ff7a00]/10 rounded-full blur-2xl pointer-events-none" />
          
          <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-6">
            
            {/* Left Side: Tagline, Title, Subtitle & Quote */}
            <div className="space-y-3.5 max-w-3xl">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-white/10 rounded-full border border-white/20 text-xs font-bold uppercase tracking-wider text-[#ffd22e]">
                <span className="w-2 h-2 bg-[#ffd22e] rounded-full animate-ping" />
                PORTAL DIGITAL RW 14
              </div>

              <div>
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold tracking-tight text-white leading-tight">
                  CIBUBUR <span className="text-[#ffd22e]">VILLA 2 DIGITAL</span>
                </h1>
                <p className="text-sm sm:text-base font-medium text-emerald-100/90 mt-1">
                  Portal Informasi, Pelayanan dan Kolaborasi Warga Perumahan Cibubur Villa 2
                </p>
              </div>

              <div className="pl-3.5 py-1.5 border-l-4 border-[#ffd22e] text-xs sm:text-sm italic text-[#ffd22e] bg-white/5 rounded-r-xl max-w-2xl">
                <p className="font-semibold">
                  “Bersama Warga Membangun Lingkungan yang Maju, Berkah dan Peduli”
                </p>
              </div>
            </div>

            {/* Right Side: CTA Buttons */}
            <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row items-stretch sm:items-center gap-3 shrink-0">
              <button
                onClick={() => onOpenModal("surat")}
                className="px-6 py-3.5 bg-[#006837] hover:bg-[#008f4c] text-white font-bold rounded-xl text-xs tracking-wider flex items-center justify-center gap-2.5 shadow-lg border border-white/20 hover:border-white/40 transition-all cursor-pointer hover:-translate-y-0.5 active:translate-y-0"
              >
                <FileText className="w-4 h-4 text-[#ffd22e]" />
                AJUKAN SURAT
              </button>

              <button
                onClick={() => onOpenModal("aspirasi")}
                className="px-6 py-3.5 bg-[#ff7a00] hover:bg-[#e06b00] text-white font-bold rounded-xl text-xs tracking-wider flex items-center justify-center gap-2.5 shadow-lg transition-all cursor-pointer hover:-translate-y-0.5 active:translate-y-0"
              >
                <MessageSquare className="w-4 h-4 text-white" />
                ASPIRASI WARGA
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
  );
}
